import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const apartadoPdf = (values) => {
  const empresa = values.data.empresa;
  const cliente = values.data.cliente;
  const logoBiwo = values.logoBiwo;

  const conceptos = (values.data.insumosApartados || [])
    .filter((item) => item.apartar > 0)
    .map(({ clave, descripcion, apartar }) => [
      { text: clave || "", style: "textoTabla", alignment: "center" },
      { text: descripcion || "", style: "textoTabla", alignment: "left" },
      { text: apartar.toString(), style: "textoTabla", alignment: "right" },
    ]);

  return {
    footer: function () {
      return {
        image: "logoBiwo",
        alignment: "center",
        width: 50,
        margin: [0, 0, 0, 10],
      };
    },
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          body: [[
            { border: [false, false, false, false], image: "logo", fit: [80, 80] },
            {
              border: [false, false, false, false],
              table: {
                widths: ["100%"],
                body: [
                  [{ text: empresa.nombre || "-", style: "tableHeader" }],
                  [{ text: `RFC: ${empresa.rfc || "-"}`, style: "textoChico", alignment: "center" }],
                  [{ text: `${empresa.calle || "-"} ${empresa.numeroCalle || "-"}`, style: "textoChico", alignment: "center" }],
                  [{
                    text: `${empresa.colonia?.nombre || ""}, C.P. ${empresa.colonia?.cp || ""}, ${empresa.municipio?.nombre || ""}, ${empresa.estado?.nombre || ""}`,
                    style: "textoChico",
                    alignment: "center",
                  }],
                  [{ text: "APARTADO DE INSUMOS", style: "tableHeader" }],
                ],
              },
              layout: "noBorders",
            },
            {
              border: [false, false, false, false],
              table: {
                widths: ["100%"],
                body: [
                  [{ text: "Fecha:", style: "subheader", alignment: "center" }],
                  [{ text: moment().format("LL"), style: "textoChico", alignment: "center" }],
                ],
              },
              layout: "noBorders",
            },
          ]],
        },
      },
      {
        style: "tableExample",
        table: {
          widths: ["100%"],
          body: [[{
            table: {
              widths: ["15%", "35%", "15%", "35%"],
              body: [
                [
                  { text: "Cliente:", style: "subheader" },
                  {
                    text: cliente.persona
                      ? cliente.razonSocial || "-"
                      : `${cliente.nombre || ""} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim(),
                    style: "textoChico",
                  },
                  { text: "RFC:", style: "subheader" },
                  { text: cliente.rfc || "-", style: "textoChico" },
                ],
                [
                  { text: "Correo:", style: "subheader" },
                  { text: cliente.correo || "-", style: "textoChico" },
                  { text: "Teléfono:", style: "subheader" },
                  { text: cliente.telefono?.toString() || "-", style: "textoChico" },
                ],
              ],
            },
            layout: "noBorders",
          }]],
        },
      },
      {
        style: "tableExample",
        table: {
          widths: ["20%", "60%", "20%"],
          body: [
            [
              { text: "Clave", style: "tituloTabla" },
              { text: "Descripción", style: "tituloTabla" },
              { text: "Cantidad Apartada", style: "tituloTabla" },
            ],
            ...conceptos,
          ],
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
        },
      },
      {
        style: "tableExample",
        margin: [0, 50, 0, 0],
        table: {
          widths: ["35%", "30%", "35%"],
          body: [[
            { text: "Entrega", style: "textoTabla", alignment: "center", border: [false, true, false, false] },
            { text: "", border: [false, false, false, false] },
            { text: "Recibe", style: "textoTabla", alignment: "center", border: [false, true, false, false] },
          ]],
        },
      },
    ],
    images: {
      logo: empresa.logo?.base64Completa || "",
      logoBiwo: logoBiwo?.base64Completa || "",
    },
    styles: {
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      textoChico: { fontSize: 8 },
      tituloTabla: { fontSize: 8, bold: true, fillColor: "#cccccc", alignment: "center" },
      textoTabla: { fontSize: 8 },
    },
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 20],
  };
};

export default apartadoPdf;